<template lang="html">
  <section class="sub-main take-place column actualities">
		<div class="ctn-layout column">
			<div class="menu-actu row">
				<div class="btn btn-red" @click="showModalShareNews=true">
					<span class="icon-button-diffusion"></span>
					Diffuser un article
				</div>
			</div>
			<div class="actualities-content">
				<div class="title">
					Les derniers articles de Patrimoffice
				</div>
				<div class="ctn-main-articles row">
					<router-link :to="{ name: 'Article', params: { id: article.id } }"class="article-main" v-for="(article, key) in newNews" v-bind:key="key">
						<div class="ctn-cover">
							<img :src="article.image" alt="">
						</div>
						<div class="content-article">
							<div class="head-article row">
								<div class="date">
									<span class="icon-clock"></span>
									{{ article.updated_at | moment('DD/MM/YY') }}
								</div>
								<div class="author">
									<span class="icon-paysage-vous"></span>
									{{ article.author.name }}
								</div>
							</div>
							<div class="title-article">
								{{ article.title }}
							</div>
							<div class="ctn-tags row">
								<div class="tag" v-for="(tag, keyt) in article.tags" v-bind:key="keyt">
									{{ tag }}
								</div>
							</div>
							<div class="ctn-description" v-html="strip(article.body)"></div>
						</div>
					</router-link>
				</div>
				<div class="ctn-small-articles-container row">
					<div class="ctn-small-articles-part">
						<div class="title">
							Tous les articles de Patrimoffice
						</div>
						<div class="ctn-small-articles">
							<div class="small-article row" v-for="(article, key) in restNews" v-bind:key="key">
								<div class="ctn-cover">
									<img :src="article.image" alt="">
								</div>
								<div class="ctn-title column">
									<div class="article-title">{{ article.title }}</div>
									<div class="header-article row">
										<div class="date">
											<span class="icon-clock"></span>
											{{ article.updated_at | moment('DD/MM/YY') }}
										</div>
										<div class="author">
											<span class="icon-paysage-vous"></span>
											{{ article.author.name }}
										</div>
									</div>
								</div>
								<div class="ctn-cta">
									<router-link :to="{ name: 'Article', params: { id: article.id }}" class="btn btn-gold">
										Voir l'article
									</router-link>
								</div>
							</div>
						</div>
						<div class="no-article" v-if="restNews.length === 0">
							Pas encore d'articles partagés
						</div>
					</div>
					<div class="ctn-small-articles-part">
						<div class="title">
							Les derniers articles partagés
						</div>
						<div class="ctn-small-articles">
							<div class="small-article row" v-for="(article, key) in myNews" v-bind:key="key">
								<div class="ctn-cover">
									<img :src="article.image" alt="">
								</div>
								<div class="ctn-title column">
									<div class="article-title">{{ article.title }}</div>
									<div class="header-article row">
										<div class="date">
											<span class="icon-clock"></span>
											{{ article.updated_at | moment('DD/MM/YY H:m') }}
										</div>
										<div class="author">
											<span class="icon-paysage-vous"></span>
											{{ article.author.name }}
										</div>
									</div>
								</div>
								<div class="ctn-cta">
									<a :href="article.link" target="_blank" class="btn btn-gold">
										Voir l'article
									</a>
								</div>
							</div>
							<div class="no-article" v-if="myNews.length === 0">
								Pas encore d'articles partagés
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="showModalShareNews" @close="showModalShareNews = false" :content="modalShareNews" />
  </section>
</template>

<script>
import ModalShareNews from '@/components/Modal/ShareNews'
import { mapGetters } from 'vuex'
export default {
	name: 'Actualities',
	data () {
		return {
			showModalShareNews: false,
			modalShareNews: ModalShareNews,
			newNews: [],
			restNews: []
		}
	},
	mounted () {
		this.$store.dispatch('fetchAllNews').then(() => {
			this.newNews = this.news.slice(0, 4)
			this.restNews = this.news.slice(4)
		})
	},
	methods: {
		strip (s) { return s.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 120) + '...' }
	},
	computed: {
		...mapGetters({
			news: 'allNews',
			beforeMyNews: 'writtedNews'
		}),
		myNews () {
			return this.beforeMyNews || []
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Actualities.vue?5bd17844